import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "submitButton"];

  connect() {
    this.updateSubmitButtonState();
  }

  toggleSubmitButton() {
    this.updateSubmitButtonState();
  }

  updateSubmitButtonState() {
    this.submitButtonTarget.disabled = !this.checkboxTarget.checked;
  }
}
